interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}

const LOGO_URL = 'https://static.lumi.new/98/981fc72d8655fd6043bb5043142b5cce.webp';

function Logo({ className = '', variant = 'dark' }: LogoProps) {
  const wordmarkColor = variant === 'light' ? 'text-white' : 'text-slate-900';
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Beeznz Work"
        className="h-8 w-auto object-contain"
        loading="eager"
        decoding="async" />

      


    </div>);

}

export default Logo;